import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12109b25"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "star-rating" }
const _hoisted_2 = { class: "tooltip-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tooltip" }, "Esta calificación la da el ciudadano", -1))


import { mdiInformation } from "@mdi/js";
import SvgIcon from "@jamescoyle/vue-icon";

// Define los props con sus tipos

export default /*#__PURE__*/_defineComponent({
  props: {
    rating: null
  },
  setup(__props: any) {

const props = __props as {
  rating: number;
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (index) => {
      return _createElementVNode("span", {
        key: index,
        class: _normalizeClass(["star", { filled: index <= props.rating }])
      }, " ★ ", 2)
    }), 64)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(SvgIcon), {
        path: _unref(mdiInformation),
        type: "mdi",
        class: "info-icon"
      }, null, 8, ["path"]),
      _hoisted_3
    ])
  ]))
}
}

})